import "./DescriptionProject.css"


const DescriptionProject = () => {


    return (
        <div className="descroption-project hidden">
            <img/>
            <p>Descrição</p>
            <a>Link</a>
            <div>
                <ul>
                    <li>Python</li>
                    <li>HTML</li>
                    <li>JS</li>
                </ul>
            </div>
        </div>
    );
}


export default DescriptionProject;